import { Link, useNavigate } from "react-router-dom";
import { Button } from "../ui/button";
import { useAuth } from "../../App";

export const FinalCTA = () => {
  const { user } = useAuth();
  const navigate = useNavigate();

  return (
    <section className="py-20 px-4 bg-[#FAFBFC]" data-testid="final-cta-section">
      <div className="max-w-2xl mx-auto text-center">
        <h2 className="text-2xl sm:text-3xl font-semibold mb-4 text-gradient-brand">
          Your routine is out there. Someone's already shared it.
        </h2>
        <p className="text-muted-foreground text-sm sm:text-base mb-8 max-w-md mx-auto">
          Join a community that values honesty over hype. Your experience — good or bad — helps someone else make a better choice.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          {user ? (
            <>
              <Link to="/routines">
                <Button size="lg" className="rounded-full px-10 h-12 text-base font-medium" data-testid="cta-track-routine">
                  Track Your Routine
                </Button>
              </Link>
              <Link to="/upload">
                <Button variant="outline" size="lg" className="rounded-full px-10 h-12 text-base font-medium" data-testid="cta-upload-review">
                  Share Your Experience
                </Button>
              </Link>
            </>
          ) : (
            <>
              <Button
                size="lg"
                className="rounded-full px-10 h-12 text-base font-medium shadow-lg shadow-primary/20"
                onClick={() => navigate("/login")}
                data-testid="cta-join-btn"
              >
                Join the Community
              </Button>
              <Link to="/products">
                <Button variant="outline" size="lg" className="rounded-full px-10 h-12 text-base font-medium" data-testid="cta-explore-btn">
                  Explore Products
                </Button>
              </Link>
            </>
          )}
        </div>
      </div>
    </section>
  );
};
